import React from 'react';
import { isItemTaxable } from '../../utils/priceIgvUtils';

const IgvYesNoSelect = ({ value, onChange, disabled = false, className = '' }) => {
  const selected =
    value === undefined || value === null ? 'yes' : isItemTaxable(value) ? 'yes' : 'no';

  return (
    <select
      value={selected}
      onChange={(e) => onChange(e.target.value === 'yes')}
      disabled={disabled}
      className={`px-2 py-1 border border-gray-300 rounded text-sm focus:outline-none focus:ring-2 focus:ring-teal-500 disabled:bg-gray-50 ${className}`}
      aria-label="¿Afecto a IGV?"
    >
      <option value="yes">Sí</option>
      <option value="no">No</option>
    </select>
  );
};

export default IgvYesNoSelect;
